var render = function (_h,_vm) {var _c=_vm._c;return _c('button',{class:['blue-btn', _vm.props.extraClass],attrs:{"disabled":_vm.props.disabled},on:{"click":_vm.listeners.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }